"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setStickyColumnCellPosition = void 0;
var setStickyColumnCellPosition = function (container) {
    var cells = container.querySelectorAll('[data-is-sticky-column="true"]');
    var accumulationWidth = 0;
    cells.forEach(function (cell) {
        var cellIndex = parseInt(cell.dataset.cellIndex);
        if (cellIndex === 0)
            accumulationWidth = 0;
        cell.style.left = accumulationWidth + "px";
        accumulationWidth += cell.offsetWidth;
    });
};
exports.setStickyColumnCellPosition = setStickyColumnCellPosition;
//# sourceMappingURL=setStickyColumnCellPosition.js.map